import {
  IAiReceptionistSettings,
  AiReceptionistFieldErrors,
} from '@dataTypes/index'
import { stripSmsMarkup } from '@utils/communicationFlow.util'

const REQUIRED_FIELD_MESSAGE = 'This field is required'
const REQUIRED_SELECTION_MESSAGE = 'At least 1 must be selected'

const hasSelection = (value: string[] | undefined): boolean =>
  Array.isArray(value) && value.length > 0

const hasText = (value: string | undefined): boolean =>
  stripSmsMarkup(value).length > 0

export const getAiReceptionistFieldErrors = (
  settings: IAiReceptionistSettings,
): AiReceptionistFieldErrors => {
  if (!settings.enabled) return {}

  const errors: AiReceptionistFieldErrors = {}
  if (!hasSelection(settings.channels)) {
    errors.channels = REQUIRED_SELECTION_MESSAGE
  }
  if (!hasSelection(settings.controls)) {
    errors.controls = REQUIRED_SELECTION_MESSAGE
  }
  if (!hasSelection(settings.languages)) {
    errors.languages = REQUIRED_SELECTION_MESSAGE
  }
  if (
    settings.verification_enabled !== false &&
    !hasSelection(settings.verification_fields)
  ) {
    errors.verification_fields = REQUIRED_SELECTION_MESSAGE
  }
  if (
    settings.verification_enabled !== false &&
    !hasSelection(settings.verification_required_for)
  ) {
    errors.verification_required_for = REQUIRED_SELECTION_MESSAGE
  }
  if (!hasSelection(settings.services)) {
    errors.services = REQUIRED_SELECTION_MESSAGE
  }

  const channels = Array.isArray(settings.channels) ? settings.channels : []
  const controls = settings.controls ?? []
  if (channels.includes('call')) {
    if (!hasText(settings.voice_style)) {
      errors.voice_style = REQUIRED_FIELD_MESSAGE
    }
    if (!hasText(settings.voice_tone)) {
      errors.voice_tone = REQUIRED_FIELD_MESSAGE
    }
  }
  if (controls.includes('new_booking')) {
    if (!hasText(settings.sms_booking_unconfirmed)) {
      errors.sms_booking_unconfirmed = REQUIRED_FIELD_MESSAGE
    }
    if (!hasText(settings.sms_booking_confirmed)) {
      errors.sms_booking_confirmed = REQUIRED_FIELD_MESSAGE
    }
  }
  if (controls.includes('reschedule') && !hasText(settings.sms_reschedule)) {
    errors.sms_reschedule = REQUIRED_FIELD_MESSAGE
  }
  if (controls.includes('cancel') && !hasText(settings.sms_cancel)) {
    errors.sms_cancel = REQUIRED_FIELD_MESSAGE
  }

  if (channels.includes('sms')) {
    const responseValue = Number(settings.sms_default_response_value)
    const unit = settings.sms_default_response_unit
    if (
      !Number.isFinite(responseValue) ||
      responseValue < 1 ||
      (unit !== 'minutes' && unit !== 'hours')
    ) {
      errors.sms_default_response_value = REQUIRED_FIELD_MESSAGE
    }
  }

  return errors
}
